<template>
    <fci-dialog :title="this.$f.tc('button')" v-model="show">
        <v-form ref="form" v-model="formValid" @submit="submit" class="ButtonSelector pa-3">
            <v-autocomplete
                outlined
                dense
                :label="this.$f.tc('button')"
                :items="buttonList"
                item-text="title"
                :return-object="true"
                v-model="button"
                :rules="formRules.required"
            ></v-autocomplete>
            <v-layout>
                <v-flex></v-flex>
                <v-btn color="primary" type="submit">{{ $f.tc('select') }}</v-btn>
            </v-layout>
        </v-form>
    </fci-dialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import { ButtonType, CardType, DefaultAllowButtonType } from '@/utils/const'
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'

export default {
    name: 'ButtonSelector',
    components: { FciDialog },
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            buttonList: [],
            button: null,
            allowButtonType: DefaultAllowButtonType
        }
    },
    methods: {
        open (config) {
            if (config && config.allowButtonType) {
                this.allowButtonType = config.allowButtonType
            } else {
                this.allowButtonType = DefaultAllowButtonType
            }
            let buttonList = []
            this.$store.state.scenario.cardList.forEach(card => {
                if (card.config.buttons) {
                    buttonList.push(...card.config.buttons)
                } else if (card.card_type_id === CardType.CAROUSEL) {
                    card.config.carousel_cards.forEach(carousel => {
                        buttonList.push(...carousel.buttons)
                    })
                }
            })
            this.buttonList = buttonList.filter(button => this.allowButtonType[this.getType(button)])
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        getType (button) {
            if (!button) {
                return ButtonType.GO_TO_STEP
            }
            for (let i in ButtonType) {
                if (button[ButtonType[i]]) {
                    return ButtonType[i]
                }
            }
            return ButtonType.GO_TO_STEP
        },
        submitValidForm () {
            this.promise.resolve(this.button)
            this.button = null
            this.close()
        }
    },
    watch: {
        show () {
            if (!this.show) {
                this.clearForm()
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
